module.exports = __webpack_public_path__ + "assets/img/arrow_head_bottom_blue.84e87ccb.svg";